import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	noValue: {
		id: 'business-fields.radio-select.cell.no-value',
		defaultMessage: 'None',
		description: 'Value to select when you want to clear the currently selected option',
	},
	placeholder: {
		id: 'business-fields.radio-select.cell.placeholder',
		defaultMessage: 'Select { fieldName }',
		description: 'Placeholder text to see when a select radio has no value',
	},
	label: {
		id: 'business-fields.radio-select.cell.label',
		defaultMessage: '{ fieldName }',
		description: 'Label for inline radio select input',
	},
});
